/**
 * Custom Knockout bindings
 * Imported once in app.js, before ko.applyBindings
 */
import ko from 'knockout';
import { highlightMatches } from './textSearch.js';

/**
 * highlightedHtml: like the html binding, then highlights matches of a search query
 * and scrolls the first one into view.
 * Usage: data-bind="highlightedHtml: { html: someHtml(), query: searchQuery() }"
 */
ko.bindingHandlers.highlightedHtml = {
    init() {
        // Same as the built-in html binding: the inserted HTML isn't bound by Knockout
        return { controlsDescendantBindings: true };
    },
    update(element, valueAccessor) {
        const { html, query } = ko.unwrap(valueAccessor()) || {};
        ko.utils.setHtml(element, ko.unwrap(html) || '');
        const firstMark = highlightMatches(element, ko.unwrap(query));
        if (firstMark) {
            firstMark.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
    }
};
